module.exports = __webpack_public_path__ + "static/media/logo.00d43fef.png";